import { SkeletonForTypography } from './style/SkeletonForTypography';

export default SkeletonForTypography;
